(function () {
  function clamp(n, a, b) {
    return Math.max(a, Math.min(b, n));
  }

  function init(root) {
    var track = root.querySelector("[data-ir-ingredients-track]");
    var controls = root.querySelector("[data-ir-ingredients-controls]");
    var range = root.querySelector("[data-ir-ingredients-range]");
    var prev = root.querySelector("[data-ir-ingredients-prev]");
    var next = root.querySelector("[data-ir-ingredients-next]");
    if (!track || !controls || !range || !prev || !next) return;

    var isSyncingFromRange = false;
    var isSyncingFromScroll = false;

    function isMobile() {
      return window.matchMedia("(max-width: 749px)").matches;
    }

    function getMaxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function getStep() {
      var first = track.querySelector(".ir-ingredients__card");
      if (!first) return 0;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || "0") || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function updateButtons() {
      if (!isMobile()) return;
      var maxScroll = getMaxScroll();
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= maxScroll - 1;
    }

    function syncRangeFromScroll() {
      if (!isMobile()) return;
      if (isSyncingFromRange) return;

      var maxScroll = getMaxScroll();
      var ratio = maxScroll <= 0 ? 0 : track.scrollLeft / maxScroll;
      var v = Math.round(clamp(ratio, 0, 1) * 1000);

      isSyncingFromScroll = true;
      range.value = String(v);
      isSyncingFromScroll = false;

      updateButtons();
    }

    function syncScrollFromRange() {
      if (!isMobile()) return;
      if (isSyncingFromScroll) return;

      var maxScroll = getMaxScroll();
      var v = parseInt(range.value || "0", 10);
      var ratio = clamp(v / 1000, 0, 1);
      var x = ratio * maxScroll;

      isSyncingFromRange = true;
      track.scrollTo({ left: x, behavior: "auto" });
      isSyncingFromRange = false;

      updateButtons();
    }

    function scrollByDir(dir) {
      var step = getStep();
      if (!step) return;
      track.scrollBy({ left: dir * step, behavior: "smooth" });
    }

    prev.addEventListener("click", function () {
      scrollByDir(-1);
    });

    next.addEventListener("click", function () {
      scrollByDir(1);
    });

    range.addEventListener("input", function () {
      syncScrollFromRange();
    });

    track.addEventListener(
      "scroll",
      function () {
        syncRangeFromScroll();
      },
      { passive: true }
    );

    function refresh() {
      if (!isMobile()) return;
      var maxScroll = getMaxScroll();
      range.disabled = maxScroll <= 0;
      syncRangeFromScroll();
    }

    window.addEventListener("resize", function () {
      refresh();
    });

    refresh();
  }

  function boot() {
    var nodes = document.querySelectorAll("[data-ir-ingredients]");
    if (!nodes.length) return;
    nodes.forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
